// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { SectionIcon } from '../../icons';
import { cssInJS } from '../../utils/styles';

export default class MetadataTitle extends React.Component {
  static propTypes = {
    onClick: PropTypes.func,
    expanded: PropTypes.bool.isRequired,
    title: PropTypes.string,
  };

  render() {
    const { styles } = MetadataTitle;
    const { title } = this.props;

    return (
      <div
        className={css(styles.section)}
        onClick={this.props.onClick}
      >
        <div className={css(styles.icon)}><SectionIcon className={css(!this.props.expanded && styles.collapsed)} /></div>
        <div className={css(styles.title)}>
          <span className={css(styles.label)}>{title || 'Metadata'}</span>
        </div>
      </div>
    );
  }
}

const styles = cssInJS({
  section: {
    display: 'flex',
    flexDirection: 'row',
    minHeight: 36,
    background: THEME.sectionTitleBackground,
    borderBottom: THEME.fieldBorderMedium,
    cursor: 'pointer',
    fontWeight: 'bold',

    ':hover': {
      background: THEME.sectionTitleBackgroundHover,
    },
  },

  icon: {
    borderRight: THEME.fieldBorderMedium,
    width: 37,
    height: 35, // this style is for IE10
    padding: 8,
    paddingBottom: 0,
    display: 'inline-block',
  },

  collapsed: {
    opacity: 0.2,
  },

  title: {
  },

  label: {
    display: 'inline-block',
    paddingTop: 9,
    paddingLeft: 12,
    fontSize: 14,
  },
});

MetadataTitle.styles = styles;
